const { formatMoney } = window.BAO.Utils

class ProductEngraving extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleApply = this.handleApply.bind(this)

    this.els.select?.elements.forEach((selectEl) => {
      this.listeners.add(selectEl, 'change', this.handleSelectChange)
    })

    this.els.input?.elements.forEach((inputEl) => {
      this.listeners.add(inputEl, 'input', this.handleInputChange)
    })
    this.listeners.add(this.els.apply.element, 'click', this.handleApply)
  }

  handleInputChange (event) {
    const inputEl = event.target.closest(this.els?.input?.selector)
    if (!inputEl) return

    let count

    // Use Intl.Segmenter if available for accurate grapheme cluster segmentation
    if (Intl && Intl.Segmenter) {
      const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' })
      count = [...segmenter.segment(inputEl.value)].length
    } else {
      // Fallback to spread operator for emoji handling
      count = [...inputEl.value].length
    }

    // Update character count display
    const countEl = this.els.count.elements.find(
      (countEl) => countEl.dataset.field === inputEl.dataset.field,
    )

    if (countEl) {
      countEl.innerHTML = count
    }

    // Validate emojis in the input
    this.handleEmojiChecker(event)
  }

  handleEmojiChecker (event) {
    const emojiCharacters = /[\p{Emoji}]/gu // Match all emojis (ES2021+)
    const allowedValues = [
      '❤',
      '❤️',
      '⭐',
      ...Array.from({ length: 10 }, (_, i) => i.toString()),
    ] // Allowed emojis with variations, numbers 0-9
    const inputValue = event.target.value
    const inputElContainer = event.target.closest('.drw-Personalisation_Item')
    const applyButton = this.els.apply.element
    const foundEmojis = inputValue.match(emojiCharacters) || []
    const normalizeEmoji = (emoji) => emoji.normalize('NFC')

    const disallowedValues = foundEmojis.filter(
      (emoji) => !allowedValues.includes(normalizeEmoji(emoji)),
    )

    if (disallowedValues.length > 0) {
      if (!inputElContainer.querySelector('.drw-Personalisation_ItemError')) {
        const errorMessage = document.createElement('p')

        errorMessage.textContent =
          window.theme.strings.emojiPersonalisationErrorMessage
        errorMessage.className = 'drw-Personalisation_ItemError'

        inputElContainer.appendChild(errorMessage)
      }

      applyButton.disabled = true
    } else {
      if (inputElContainer.querySelector('.drw-Personalisation_ItemError')) {
        inputElContainer
          .querySelector('.drw-Personalisation_ItemError')
          .remove()
      }

      applyButton.disabled = false
    }
  }

  handleSelectChange (event) {
    const matchedSelect = this.els.select?.elements.find((selectEl) =>
      selectEl.value.includes(':: Additional Cost'),
    )

    this.els.cost?.elements.forEach((costEl) => {
      costEl.setAttribute('aria-hidden', !matchedSelect)
    })

    this.setAttribute('data-additional-costs', !!matchedSelect)
  }

  handleApply () {
    let inputsPopulated = !this.els.input?.exists
    let personalisationCost = 0

    this.els.product?.elements.forEach((productEl) => {
      const matchedHiddenEl = this.externalEls.hiddeninput.elements.find(
        (hiddenEl) =>
          hiddenEl.dataset.field === productEl.dataset.field &&
          hiddenEl.dataset.formId === this.formId,
      )

      if (
        productEl.value !== '' &&
        !productEl.hasAttribute('product-form-personalisation-required')
      ) {
        personalisationCost =
          personalisationCost +
          parseInt(productEl.options[productEl.selectedIndex].dataset.cost)
      }

      const filteredEls = this.externalEls.additionalproduct?.elements.filter(
        (additionalproductEl) =>
          additionalproductEl.dataset.formId === this.formId,
      )
      filteredEls?.forEach((additionalProductEl) => {
        if (additionalProductEl.dataset.field === productEl.dataset.field) {
          if (productEl.value !== '') {
            additionalProductEl.removeAttribute('disabled')

            if (additionalProductEl.dataset.addValue === 'true') {
              additionalProductEl.value = productEl.value
            }
          } else {
            additionalProductEl.setAttribute('disabled', '')
          }
        }
      })

      if (productEl.value !== '') {
        matchedHiddenEl.value =
          productEl.options[productEl.selectedIndex].dataset.name
        matchedHiddenEl.removeAttribute('disabled')
      } else {
        matchedHiddenEl.value = ''
        matchedHiddenEl.setAttribute('disabled', '')
      }
    })

    const filteredHiddenInputEls = this.externalEls.hiddeninput.elements.filter(
      (hiddeninputEl) => hiddeninputEl.dataset.formId === this.formId,
    )

    this.els.input?.elements.forEach((inputEl) => {
      const matchedHiddenEl = filteredHiddenInputEls.find(
        (hiddenEl) => hiddenEl.dataset.field === inputEl.dataset.field,
      )

      if (
        this.addCharges &&
        inputEl.value !== '' &&
        inputEl.dataset.additionalCost !== undefined
      ) {
        personalisationCost =
          personalisationCost + parseInt(inputEl.dataset.additionalCost)
      }

      const filteredAdditionalChargeEls =
        this.externalEls.additionalcharge?.elements.filter(
          (additionalchargeEl) =>
            additionalchargeEl.dataset.formId === this.formId,
        )
      filteredAdditionalChargeEls?.forEach((additionalChargeEl) => {
        if (additionalChargeEl.dataset.field === inputEl.dataset.field) {
          if (inputEl.value !== '' && this.addCharges) {
            additionalChargeEl.removeAttribute('disabled')
            if (additionalChargeEl.dataset.addValue === 'true') {
              additionalChargeEl.value = inputEl.value
            }
          } else {
            additionalChargeEl.setAttribute('disabled', '')
          }
        }
      })

      if (inputEl.value === '') {
        matchedHiddenEl.value = ''
        matchedHiddenEl.setAttribute('disabled', '')
      } else {
        matchedHiddenEl.value = inputEl.value
        matchedHiddenEl.removeAttribute('disabled')

        inputsPopulated = true
      }
    })

    this.els.select?.elements.forEach((selectEl) => {
      const matchedHiddenEl = filteredHiddenInputEls.find(
        (hiddenEl) => hiddenEl.dataset.field === selectEl.dataset.field,
      )

      if (inputsPopulated) {
        matchedHiddenEl.value = selectEl.value
        matchedHiddenEl.removeAttribute('disabled')
      } else {
        matchedHiddenEl.value = ''
        matchedHiddenEl.setAttribute('disabled', '')
      }
    })

    const triggerEl = this.externalEls.trigger.elements.find(
      (triggerEl) => triggerEl.dataset.formId === this.formId,
    )
    const triggerLabelEl = this.externalEls.triggerlabel.elements.find(
      (triggerlabelEl) => triggerlabelEl.dataset.formId === this.formId,
    )
    const triggerCostEl = this.externalEls.cost.elements.find(
      (costEl) => costEl.dataset.formId === this.formId,
    )

    triggerEl.classList.toggle('prd-Form_Variant-required', false)

    if (inputsPopulated) {
      triggerLabelEl.classList.toggle('prd-Form_VariantText-light', false)
      triggerLabelEl.textContent = triggerLabelEl.dataset.edit

      if (personalisationCost > 0) {
        triggerCostEl.textContent = `+${formatMoney(personalisationCost)}`
      } else {
        triggerCostEl.textContent = ''
      }
    } else {
      triggerLabelEl.classList.toggle('prd-Form_VariantText-light', true)
      triggerLabelEl.textContent = triggerLabelEl.dataset.add

      triggerCostEl.textContent = ''
    }

    window.BAO.additionalCosts = personalisationCost

    window.BAO.dispatchEvent(window.BAO.EVENTS.PDP.UPDATE_PRICE)

    this.handlePriceUpdate()
  }

  handlePriceUpdate () {
    // If there are variants, this is already handled by the variants.js script
    const hasVariants =
      document.querySelector('variant-radios') ||
      document.querySelector('variant-selects')
    if (hasVariants) return

    // If there are no variants, we need to update the price
    const basePrice = Number.parseFloat(this.dataset.basePrice || 0)
    for (const priceEl of this.externalEls.price?.elements ?? []) {
      priceEl.innerHTML = formatMoney(basePrice + window.BAO.additionalCosts)
    }
  }

  get addCharges () {
    return this.dataset.additionalCosts === 'true'
  }

  get formId () {
    return this.dataset.formId
  }
}

if (!customElements.get('product-engraving')) {
  customElements.define('product-engraving', ProductEngraving)
}
